module.exports = __webpack_public_path__ + "media/images/icons/chat-close-9d8dcad052e6caa79f89996dc2ba75a4.svg";